import "./UploadHome.css";
import { useNavigate } from "react-router";
import { useRef, useState, useContext, useEffect } from "react";
import ReactPlayer from "react-player";
import arrow2 from "../../assests/arrow2.svg";
import Context from "../../context/Context";
import participateSample from "../../assests/participateSample.png";
import participateSampleWp from "../../assests/participateSampleWp.png";
import Header from "../Header/Header";
import _, { isEmpty } from "lodash";
import closebutton from "../../assests/closebutton.svg";
import youtube from "../../assests/youtube.svg";
import { mediaStorage } from "../../store/firebase-config";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  uploadString,
} from "firebase/storage";
import UploadFormNew from "../UploadFormNew/UploadFormNew";
import axios from "axios";
import { useUserAuth } from "../../context/UserAuthContext";
import ProgressBand from "../ProgressBand/ProgressBand";
import UploadSuccess from "../UploadSuccess/UploadSucess";
import NavigationHeader from "../NavigationHeader/NavigationHeader";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import FloatingWidgets from "../FloatingWidgets/FloatingWidgets";
import UploadErrorPopup from "../UploadErrorPopup/UploadEroorPopup";
import { createSearchParams } from "react-router-dom";
import UploadPopup from "../UploadPopup/UploadPopup";
import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import YoutubeUploadPopup from "../YoutubeUploadPopup/YoutubeUploadPopup";
import CameraMask from "../CameraMask/CameraMask";

// Function to extract the 5th frame from a video as thumbnail
const extractVideoFrame = (videoUrl) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.src = videoUrl;
    video.currentTime = 0.2; // Start at 0.2 seconds, will seek to 5th frame based on FPS

    const handleSeeked = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const frameUrl = URL.createObjectURL(blob);
              video.removeEventListener("seeked", handleSeeked);
              resolve(frameUrl);
            } else {
              reject(new Error("Failed to create blob from canvas"));
            }
          },
          "image/jpeg",
          0.9,
        );
      } catch (error) {
        video.removeEventListener("seeked", handleSeeked);
        reject(error);
      }
    };

    const handleError = () => {
      video.removeEventListener("error", handleError);
      video.removeEventListener("seeked", handleSeeked);
      reject(new Error("Failed to load video"));
    };

    video.addEventListener("seeked", handleSeeked, { once: true });
    video.addEventListener("error", handleError, { once: true });

    // Set a timeout in case the video doesn't load
    setTimeout(() => {
      video.removeEventListener("seeked", handleSeeked);
      video.removeEventListener("error", handleError);
      reject(new Error("Video frame extraction timeout"));
    }, 5000);
  });
};

function UploadHome({ setParticipate, setUploading }) {
  const {
    details,
    setData,
    verifyUser,
    userIdToken,
    pinData,
    setUploadSucccess,
    validationCompleted,
    uploadSuccess,
    uploadSuccessFile,
    setUploadSucccessFile,
    preview,
    organizerName,
    campaignMetaData,
    setEnteryUploadResponse,
    generatedPosterUrl,
    setGeneratedPosterUrl,
    handleUserTracking,
    timeTaken,
    buildType,
  } = useContext(Context);

  const navigate = useNavigate();
  const inputRef = useRef();
  const [source, setSource] = useState(
    generatedPosterUrl ? [`${generatedPosterUrl}`] : [],
  );
  const contestIdData = window.location.pathname
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const campaignIdData = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  const organizerUniqueText = window.location.pathname
    .split("/")[1]
    ?.replace(/\.html$/, "");
  const orginizerName = window.location.pathname
    .split("/")[1]
    ?.replace(/\.html$/, "");
  const campaignName = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  const [loading, setLoading] = useState(false);
  const [thumbnail, setThumbnail] = useState();
  const [otherMedias, setOtherMedias] = useState({});
  const [otherMediaAfterUpload, setOtherMediaAfterUpload] = useState({});
  const [thumbailUrl, setThumbailUrl] = useState("");
  const {
    currentUser,
    userId,
    searchParams,
    setSearchParams,
    newUserId,
    loginChecker,
  } = useUserAuth();
  const voucherCode = searchParams?.get("vc");

  const [filePath, setFilePath] = useState("");
  const [uploadErrorPopup, setUploadErrorPopup] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [showYoutubeUpload, setYoutubeUpload] = useState(false);
  const [youtubeLinks, setYoutubeLinks] = useState([]);
  const [uploadPopup, setUploadPopup] = useState(false);
  const [defaultThumbnail, setDefaultThumbnail] = useState(false);
  let infId = searchParams.get("presentedBy") || searchParams.get("p");
  const [photoBoothPopup, setPhotoBoothPopup] = useState(false);
  const [initialPhotoBooth, setInitialPhotoBooth] = useState(true);
  const [stream, setStream] = useState(null);
  const [extractedFrameThumbnail, setExtractedFrameThumbnail] = useState(null);

  // const uploadedFile = pinData?.data?.data?.videoUploadURL?.split("?")[0];
  useEffect(() => {
    if (initialPhotoBooth == false && isEmpty(source)) {
      setPhotoBoothPopup(true);
    }
  }, [source]);

  useEffect(() => {
    if (!validationCompleted) {
      navigate({
        pathname: `/${organizerUniqueText}/${campaignIdData}/${contestIdData}`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  }, []);
  useEffect(() => {
    verifyUser();
  }, [orginizerName, campaignName]);
  const token = userIdToken || currentUser?.accessToken;

  useEffect(() => {
    if (isEmpty(userId) || isEmpty(newUserId)) {
      loginChecker(token);
    }
  }, []);
  // const handleFileChange = async (event) => {
  //   const data = new FormData();
  //   const file = event.target.files[0];
  //   const url = URL.createObjectURL(file);
  //   setSource(url);
  //   data.append("videoFile", file);
  //   setData(file);
  // };
  var ContentDta =
    details &&
    details.contests &&
    details.contests.find((el) => {
      return el.contestUniqueText === contestIdData;
    });
  const contestDetails = ContentDta;
  const campaignId = contestDetails?.campaignId;
  const contestId = contestDetails?.contestId;
  const organizerId = contestDetails?.orgId;
  let initialValues = {
    // participantName: currentUser?.displayName,
    email: currentUser?.email,
    tc: false,
  };

  const [formDetails, setFormDetails] = useState(initialValues);

  useEffect(() => {
    if (contestDetails?.contestType.startsWith("QUIZ")) {
      getQuizQuestions();
    }
  }, []);
  const getQuizQuestions = async () => {
    try {
      let config = {
        method: "get",
        url: `${
          process.env.REACT_APP_GET_QUESTIONS
        }/${orginizerName}/${campaignIdData}/${contestIdData}?count=${
          contestDetails?.shuffleCount || 5
        }`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      let result = await axios(config);
      // const getRandomQuestions = (array, num) => {
      //   const shuffledArray = array?.sort(() => Math.random() - 0.5);
      //   return shuffledArray.slice(0, num);
      // };

      // const randomQuestions = getRandomQuestions(result?.data?.questions, 5);

      setQuizQuestions(result?.data?.data);
    } catch (error) {
      console.log(error.message);
    }
  };
  const resetSource = () => {
    setSource("");
  };
  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };
  const handleChoose = async () => {
    inputRef.current.click();
  };
  const handleChoosePhotoBooth = async () => {
    setInitialPhotoBooth(false);
    setPhotoBoothPopup(true);
  };
  const handleCapture = (imageData) => {
    if (!imageData || imageData.size === 0) {
      console.error("No image data or image data is empty.");
      return;
    }

    const fileList = [imageData];
    setFiles(fileList);
    const newFileUrls = fileList.map((file) => URL.createObjectURL(file));
    setSource((prevFileUrls) => [newFileUrls]);
    stopCamera();
    setPhotoBoothPopup(false);
  };

  const handleNext = () => {
    setParticipate(false);
    setUploading(true);
  };
  const handleBackClick = () => {
    if (preview) {
      navigate({
        pathname: `/${organizerUniqueText}/${campaignIdData}/${contestIdData}`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/${organizerUniqueText}/${campaignIdData}/${contestIdData}`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const uploadFlow2 = async (
    cmpId,
    ctstId,
    orgId,
    thumbanilData,
    uploadCase,
    otherMediasFormDetails,
  ) => {
    setLoading(true);
    setUploadPopup(true);
    try {
      let commonData = {
        ...formDetails,
        ...otherMediasFormDetails,
        campaignName: contestDetails?.campaignName,
        contestName: contestDetails?.contestName,
        orgDomain: contestDetails?.orgDomain,
        campaignUniqueText: contestDetails?.campaignUniqueText,
        contestUniqueText: contestDetails?.contestUniqueText,
        ageGroup: contestDetails?.ageGroup,
        fileType: contestDetails?.fileType,
        infId: parseInt(infId) || "",
        timeTaken,
        voucherCode,
        platformType: buildType == "highonevent" ? "HOE" : "",
      };
      let fileRelatedData = {};

      if (uploadCase == "poster") {
        let posterFileUrl = [
          {
            fileType: "image",
            fileUrl: generatedPosterUrl,
          },
        ];
        let value = generatedPosterUrl;
        let result = value?.split("/");
        let bucketName = result[3];
        let namesAfterBucket = result?.slice(4); // This will give you an array of names after the bucketName

        fileRelatedData = {
          participationThroughPoster: true,
          fileUrls: posterFileUrl,
          thumbnailUrl: generatedPosterUrl,
          thumbnailObject: {
            bucket: bucketName,
            contentType: "image",
            name: namesAfterBucket?.join("/"),
          },
        };
      } else if (uploadCase == "defaultThumbnail") {
        let fileUrlLocal = [];
        if (!_.isEmpty(youtubeLinks)) {
          fileUrlLocal = youtubeLinks;
        } else {
          fileUrlLocal = fileUrl;
        }
        fileRelatedData = {
          defaultThumbnail: true,
          fileUrls: fileUrlLocal,
          thumbnailUrl: thumbanilData?.fileUrl,
        };
      } else {
        let fileUrlLocal = [];
        if (!_.isEmpty(youtubeLinks)) {
          fileUrlLocal = youtubeLinks;
        } else {
          fileUrlLocal = fileUrl;
        }
        fileRelatedData = {
          fileUrls: fileUrlLocal,
          contestType: contestDetails?.contestType,
          thumbnailUrl:
            contestDetails?.fileType == "video" ||
            contestDetails.fileType?.startsWith("audio")
              ? thumbanilData?.fileUrl
              : fileUrl[0]?.fileUrl,
          thumbnailObject:
            contestDetails?.fileType == "video" ||
            contestDetails.fileType?.startsWith("audio")
              ? {
                  bucket: "goviralmedias",
                  contentType: thumbanilData?.fileType,
                  name: thumbanilData?.filePath,
                }
              : {
                  bucket: "goviralmedias",
                  contentType: fileUrl[0]?.fileType,
                  name: filePath,
                },
        };
      }
      let url = "";
      if (contestDetails?.contestType.startsWith("QUIZ")) {
        url = `${process.env.REACT_APP_POST_UPLOAD_QUIZ}/${orgId}/${cmpId}/${ctstId}`;
      } else if (contestDetails?.contestType == "WPM") {
        url = `${process.env.REACT_APP_POST_UPLOAD_PREDICTION}/${orgId}/${cmpId}/${ctstId}`;
      } else {
        url = `${process.env.REACT_APP_POST_UPLOAD}/${orgId}/${cmpId}/${ctstId}`;
      }
      let config2 = {
        method: "POST",
        url: url,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          ...commonData,
          ...fileRelatedData,
        },
      };
      const response2 = await axios(config2);

      if (response2?.data?.status == "success") {
        setUploadSucccessFile({
          fileUrl: fileRelatedData?.fileUrls,
          orgId: organizerId,
          campaignId: campaignId,
          contestId: contestId,
          videoId: response2?.data?.entryId,
          participantName: formDetails?.participantName,
          description: formDetails?.description,
        });
        setEnteryUploadResponse(response2?.data);
        // setUploadStart(true);
        setGeneratedPosterUrl("");
        setUploadSucccess(true);
        setUploadPopup(false);
        // navigate(`/${organizerUniqueText}/${campaignIdData}/${contestIdData}`);
        searchParams.delete("vc"); // Remove the parameter
        setSearchParams(searchParams);
      } else {
        setEnteryUploadResponse(response2?.data);
        setGeneratedPosterUrl("");
        const responseData = response2?.data?.data;
        let errorText = "Please try again after sometime";
        if (responseData?.isVoucherValid == false) {
          if (responseData?.voucherStatus == "EXPIRED") {
            errorText =
              "You've already used this voucher code to participate. Please purchase a new one or delete your current participation to proceed.";
          } else if (responseData?.voucherStatus == "PENDING") {
            errorText =
              "Payment was not completed with this voucher code. Please purchase a new one or contact the admin for assistance.";
          }
        }
        setErrorData({
          error: "Something Went Wrong!",
          description: errorText,
        });
        setUploadErrorPopup(true);
        setUploadPopup(false);
      }
      setLoading(false);

      return response2;
    } catch (error) {
      console.log(error.message);
      setLoading(false);
      navigate("error");
    }
  };
  const thubnailUpload = async () => {
    setLoading(true);
    try {
      //add goviralMediaFiles path
      let randomId = Math.floor(Date.now() * Math.random());
      let userIdFromLocalOrApi = newUserId || userId;
      const storageRef = ref(
        mediaStorage,
        `/${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}_${contestDetails?.campaignId}_${contestDetails?.contestId}_${userIdFromLocalOrApi}_${randomId}_thumbail`,
      );
      const uploadTask = uploadBytesResumable(storageRef, thumbnail);
      let filePath = `${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}_${contestDetails?.campaignId}_${contestDetails?.contestId}_${userIdFromLocalOrApi}_${randomId}_thumbail`;
      await uploadTask;

      // const url = await getDownloadURL(uploadTask.snapshot.ref);
      const thumbanilData = {
        fileSize: thumbnail.size,
        fileType: thumbnail.type,
        fileUrl: "https://storage.googleapis.com/goviralmedias/" + filePath,
        filePath: filePath,
      };
      return thumbanilData;
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const uploadExtractedFrameThumbnail = async () => {
    if (!extractedFrameThumbnail) {
      return null;
    }

    try {
      // Convert blob URL to blob
      const response = await fetch(extractedFrameThumbnail);
      const blob = await response.blob();

      let randomId = Math.floor(Date.now() * Math.random());
      let userIdFromLocalOrApi = newUserId || userId;
      const storageRef = ref(
        mediaStorage,
        `/${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}_${contestDetails?.campaignId}_${contestDetails?.contestId}_${userIdFromLocalOrApi}_${randomId}_extracted_frame`,
      );
      const uploadTask = uploadBytesResumable(storageRef, blob);
      let filePath = `${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}_${contestDetails?.campaignId}_${contestDetails?.contestId}_${userIdFromLocalOrApi}_${randomId}_extracted_frame`;
      await uploadTask;

      const thumbanilData = {
        fileSize: blob.size,
        fileType: blob.type || "image/jpeg",
        fileUrl: "https://storage.googleapis.com/goviralmedias/" + filePath,
        filePath: filePath,
      };
      return thumbanilData;
    } catch (error) {
      console.error("Error uploading extracted frame thumbnail:", error);
      return null;
    }
  };

  const [files, setFiles] = useState(
    generatedPosterUrl ? [`${generatedPosterUrl}`] : [],
  );
  const [progress, setProgress] = useState([]);

  const [fileUrl, setFileUrl] = useState([]);

  const [
    goviralMediaUploadCompletedNumber,
    setGoviralMediaUploadCompletedNumber,
  ] = useState(0);
  const handleFileChange = (event) => {
    setUploadErrorPopup(false);
    const maxFilesAllowed = contestDetails?.maxFileNumber || null;
    const minFilesAllowed = contestDetails?.minFileNumber || null;
    const maxFileSize = (contestDetails?.maxFileSize + 5) * 1048576 || 10000000;

    const maxDurationInSeconds = contestDetails?.maxDuration || null;
    const maxDurationInMinOrSec =
      contestDetails?.maxDuration >= 60
        ? `${contestDetails?.maxDuration / 60} Minutes`
        : `${contestDetails?.maxDuration} Seconds`;

    const fileType = contestDetails?.fileType;
    const fileList = [...files, ...event.target.files];
    const fileObjects = [];

    // Iterate through the FileList and create objects
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const fileObject = {
        name: file.name,
        size: file.size,
        type: file.type,
      };
      fileObjects.push(fileObject);
    }
    handleUserTracking(event.currentTarget.id, {
      fileData: fileObjects,
    });
    // Check if the number of selected files exceeds the limit
    if (maxFilesAllowed && fileList.length > maxFilesAllowed) {
      setErrorData({
        error: `File Limit Exceeded`,
        description: `You can select up to ${maxFilesAllowed} ${contestDetails?.fileType}s.`,
      });
      setUploadErrorPopup(true);
      event.target.value = null;
      return;
    }
    // Check if the number of selected files exceeds the limit
    if (minFilesAllowed && fileList.length < minFilesAllowed) {
      setErrorData({
        error: `Minimum ${contestDetails?.fileType}s Required`,
        description: `You need minimum ${minFilesAllowed} ${contestDetails?.fileType}s to participate.`,
      });
      setUploadErrorPopup(true);
      event.target.value = null;
      return;
    }
    //checks file type
    for (let i = 0; i < event.target.files?.length; i++) {
      const file = event.target.files[i];
      const selectedFormat = file?.type;
      if (!file?.type?.includes(fileType)) {
        setErrorData({
          error: `Invalid File Type`,
          description: `Only ${fileType}s are allowed in this contest
          Selected file is ${selectedFormat} `,
        });
        setUploadErrorPopup(true);
        event.target.value = null;
        return;
      }
    }

    //checks if each file is greater than a certain size
    for (let i = 0; i < event.target.files?.length; i++) {
      const file = event.target.files[i];
      if (file?.size > maxFileSize) {
        setErrorData({
          error: `File Size Exceeded`,
          description: `The ${
            contestDetails?.fileType
          } you tried to upload is ${Math.round(
            file?.size / 1048576,
          )} MB, exceeding the ${
            contestDetails?.maxFileSize || "10"
          } MB maximum limit.
          Please reduce the file size to upload it successfully
          `,
        });
        setUploadErrorPopup(true);
        event.target.value = null;
        return;
      }
    }

    //video duration logic
    if (contestDetails?.fileType === "video" && maxDurationInSeconds !== null) {
      const checkDuration = (file) => {
        return new Promise((resolve, reject) => {
          const videoElement = document.createElement("video");
          videoElement.src = URL.createObjectURL(file);

          videoElement.onloadedmetadata = () => {
            const durationInSeconds = videoElement.duration;
            URL.revokeObjectURL(videoElement.src);

            if (durationInSeconds > maxDurationInSeconds) {
              reject(new Error("Video duration exceeds the maximum limit."));
            } else {
              resolve();
            }
          };
        });
      };

      const checkAllDurations = async () => {
        try {
          for (let i = 0; i < event.target.files?.length; i++) {
            await checkDuration(event.target.files[i]);
          }

          // All durations are within the limit
          setFiles(fileList);
          const newFileUrls = fileList.map((file) => URL.createObjectURL(file));
          setSource((prevFileUrls) => [...prevFileUrls, ...newFileUrls]);

          // Extract 5th frame from the first video as default thumbnail
          if (newFileUrls.length > 0 && !extractedFrameThumbnail) {
            extractVideoFrame(newFileUrls[0])
              .then((frameUrl) => {
                setExtractedFrameThumbnail(frameUrl);
              })
              .catch((error) => {
                console.warn(
                  "Failed to extract video frame, using default thumbnail:",
                  error,
                );
                // Fallback: use whatever default is available
                setExtractedFrameThumbnail(null);
              });
          }
        } catch (error) {
          setErrorData({
            error: `Video Duration Exceeded`,
            description: ` Video you tried adding is larger than the ${maxDurationInMinOrSec}`,
          });
          setUploadErrorPopup(true);
          event.target.value = null;
        }
      };

      checkAllDurations();
    } else {
      // For non-video files
      setFiles(fileList);
      const newFileUrls = fileList.map((file) => URL.createObjectURL(file));
      setSource((prevFileUrls) => [...prevFileUrls, ...newFileUrls]);
    }
  };

  const handleDelete = (url) => {
    const index = source.indexOf(url);
    const newFileList = [...files];
    newFileList.splice(index, 1);
    setFiles(newFileList);

    const newFileUrls = source.filter((fileUrl) => fileUrl !== url);
    setSource(newFileUrls);
    URL.revokeObjectURL(url);
  };
  const uploadGoviralMedias = async () => {
    setLoading(true);
    setUploadPopup(true);
    try {
      const goviralMediaFiles = Array.from(files);
      const medias = [...goviralMediaFiles];
      let userIdFromLocalOrApi = newUserId || userId;

      for (let i = 0; i < medias.length; i++) {
        const file = medias[i];
        // add goviralMediaFiles path
        let randomId = Math.floor(Date.now() * Math.random());
        const folderPath = `/${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}${contestDetails?.campaignId}${contestDetails?.contestId}${userIdFromLocalOrApi}${randomId}`;
        const storageRef = ref(mediaStorage, folderPath);
        let filePath = `${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/${contestDetails?.orgId}${contestDetails?.campaignId}${contestDetails?.contestId}${userIdFromLocalOrApi}${randomId}`;
        if (i === 0 && contestDetails?.fileType?.startsWith("image")) {
          setFilePath(filePath);
          // firstFilePath = filePath; // store the path of the first uploaded file
        }

        if (typeof file === "string" && file?.startsWith("data:image/")) {
          await uploadString(storageRef, file, "data_url");
        } else {
          const uploadTask = uploadBytesResumable(storageRef, file);
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              const uploadprogress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              setProgress((prevProgress) => {
                const newProgress = [...prevProgress];
                newProgress[i] = uploadprogress;

                return newProgress;
              });

              switch (snapshot.state) {
                case "paused":
                  break;
                case "running":
                  break;
              }
            },
            (error) => {
              // Handle unsuccessful uploads
            },
          );
          // Wait for the upload task to complete before proceeding to the next file
          await uploadTask;
        }

        setFileUrl((previousFileUrl) => [
          ...previousFileUrl,
          {
            fileSize: file.size,
            fileType: file.type || "image/png",
            fileUrl:
              "https://storage.googleapis.com/goviralmedias" + folderPath,
          },
        ]);
        setGoviralMediaUploadCompletedNumber(
          (previousFilesNumber) => previousFilesNumber + 1,
        );
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const uploadOtherMedias = async () => {
    setLoading(true);
    setUploadPopup(true);
    try {
      const otherMediasArray = Object.entries(otherMedias).map(
        ([key, value]) => ({ key, value }),
      );

      const goviralMediaFiles = Array.from(otherMediasArray);
      const medias = [...goviralMediaFiles];
      let userIdFromLocalOrApi = newUserId || userId;
      let otherMediasUploadResponse = {};

      for (let i = 0; i < medias.length; i++) {
        const file = medias[i]?.value;
        const key = medias[i]?.key;
        // add goviralMediaFiles path
        let randomId = Math.floor(Date.now() * Math.random());
        const folderPath = `/${contestDetails?.orgId}/${contestDetails?.campaignId}/${contestDetails?.contestId}/${userIdFromLocalOrApi}/answers/${key}_${randomId}`;
        const storageRef = ref(mediaStorage, folderPath);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const uploadprogress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress((prevProgress) => {
              const newProgress = [...prevProgress];
              newProgress[i] = uploadprogress;
              return newProgress;
            });

            switch (snapshot.state) {
              case "paused":
                break;
              case "running":
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
        );
        // Wait for the upload task to complete before proceeding to the next file
        await uploadTask;

        setOtherMediaAfterUpload((previousFileUrl) => ({
          ...previousFileUrl,
          [key]: {
            fileSize: file.size,
            fileType: file.type,
            fileUrl:
              "https://storage.googleapis.com/goviralmedias" + folderPath,
          },
        }));
        // otherMediasUploadResponse[key] = {
        //   fileSize: file.size,
        //   fileType: file.type,
        //   fileUrl: "https://storage.googleapis.com/goviralmedias" + folderPath,
        // };

        otherMediasUploadResponse[key] =
          "https://storage.googleapis.com/goviralmedias" + folderPath;
      }

      return otherMediasUploadResponse;
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const patchDetails = async (defaultThumbnailType) => {
    let cmpId = campaignId;
    let ctstId = contestId;
    let orgId = organizerId;
    let otherMediasUploadResponse = await uploadOtherMedias();

    if (
      contestDetails?.fileType === "video" ||
      contestDetails.fileType?.startsWith("audio")
    ) {
      let thumbanilData = {};

      // Priority 2: Use default thumbnail if flag is set
      if (defaultThumbnail || defaultThumbnailType) {
        thumbanilData = {
          fileUrl: details?.defaultThumbnail,
        };
        await uploadFlow2(
          cmpId,
          ctstId,
          orgId,
          thumbanilData,
          "defaultThumbnail",
          otherMediasUploadResponse,
        );
      } else {
        if (thumbnail) {
          // Priority 1: Upload custom thumbnail
          thumbanilData = await thubnailUpload();
          await uploadFlow2(
            cmpId,
            ctstId,
            orgId,
            thumbanilData,
            "normal",
            otherMediasUploadResponse,
          );
        } else {
          // Priority 2: Use extracted frame thumbnail if available
          thumbanilData = await uploadExtractedFrameThumbnail();
          if (thumbanilData) {
            await uploadFlow2(
              cmpId,
              ctstId,
              orgId,
              thumbanilData,
              "normal",
              otherMediasUploadResponse,
            );
            return;
          }
        }
      }
    } else {
      await uploadFlow2(
        cmpId,
        ctstId,
        orgId,
        "",
        "normal",
        otherMediasUploadResponse,
      );
    }
  };
  const handleYoutubeUpload = () => {
    setYoutubeUpload(true);
  };
  useEffect(() => {
    if (
      goviralMediaUploadCompletedNumber === files.length &&
      files.length > 0
    ) {
      patchDetails();
    }
  }, [goviralMediaUploadCompletedNumber, files]);

  const [isFixed, setIsFixed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const contentOffset =
        document.getElementById("content").getBoundingClientRect().top - 100;
      setIsFixed(contentOffset < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const profileHelpNavigate = () => {
    window.open(`/profile/help`);
  };
  const eventCondition = () => {
    const maxFilesAllowed = contestDetails?.maxFileNumber || null;
    const minFilesAllowed = contestDetails?.minFileNumber || null;
    const judgesInstruction = contestDetails?.judgesInstruction;
    const maxFileSize = contestDetails?.maxFileSize * 1000000 || 10000000;
    const maxDurationInSeconds = contestDetails?.maxDuration || null;
    const maxDurationInMinOrSec =
      maxDurationInSeconds >= 60
        ? `${maxDurationInSeconds / 60} Min`
        : `${maxDurationInSeconds} Sec`;

    return (
      <div
        className="flex items-center justify-center gap-[15px] mb-[24px] w-[80%] mx-auto"
        style={{ color: contestDetails?.buttonColor }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M26.2929 8.22222C23.9135 4.47027 19.8616 2 15.2632 2C7.93812 2 2 8.26802 2 16C2 23.732 7.93812 30 15.2632 30C19.1913 30 22.7206 28.1974 25.1491 25.3333M21.1579 16.4444L23.8105 19.1111L30 12.8889M15.2632 9.77778V17.5556M15.2632 22.2222H15.2779"
            stroke={contestDetails?.buttonColor}
            stroke-width="2.69"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div className="text-left ">
          <p className="text-small">
            Maximum {contestDetails?.fileType} Size :{" "}
            {contestDetails?.maxFileSize || "10"} MB
          </p>
          {maxDurationInSeconds && (
            <p className="text-small mt-[5px]">
              Maximum Duration : {maxDurationInMinOrSec}
            </p>
          )}
          {minFilesAllowed && (
            <p className="text-small mt-[5px]">
              Minimum {contestDetails?.fileType} Required : {minFilesAllowed}
            </p>
          )}
          {maxFilesAllowed && (
            <p className="text-small mt-[5px]">
              Maximum {contestDetails?.fileType} Allowed : {maxFilesAllowed}
            </p>
          )}
          {judgesInstruction && (
            <p className="text-small mt-[5px]">{judgesInstruction}</p>
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      {photoBoothPopup && (
        <CameraMask
          showPopup={photoBoothPopup}
          setShowPopup={setPhotoBoothPopup}
          handleCapture={handleCapture}
          stream={stream}
          setStream={setStream}
          handleChoose={handleChoose}
          contestDetails={contestDetails}
        />
      )}
      {uploadPopup && <UploadPopup progress={progress} />}
      {uploadErrorPopup && (
        <UploadErrorPopup
          errorData={errorData}
          setUploadErrorPopup={setUploadErrorPopup}
          backgroundColor={contestDetails?.buttonColor}
        />
      )}
      {showYoutubeUpload && (
        <YoutubeUploadPopup
          setUploadPopup={setYoutubeUpload}
          backgroundColor={contestDetails?.buttonColor}
          files={contestDetails?.maxFileNumber}
          setSource={setSource}
          setYoutubeLinks={setYoutubeLinks}
          youtubeLinks={youtubeLinks}
        />
      )}
      <div className="uploadHome flex justify-center bg-black  w-[100%] mx-auto max-w-[425px] relative min-h-[100vh]">
        <div className="upload-parentdiv pb-[50px]">
          <FloatingWidgets
            page="campaign"
            prize={details?.priceDescription}
            endTime={contestDetails?.endDate}
            color={contestDetails?.buttonColor}
          />
          <NavigationHeader type="participate" isFixed={isFixed} />
          <Header
            details={details}
            type="participate"
            coverImage={contestDetails && contestDetails?.contestPoster}
          />
          <div className="w-100%">
            <div
              className={`w-[100%]  ${
                !_.isEmpty(source)
                  ? `${
                      uploadSuccess ? "mt-[300px]" : "mt-[0px]"
                    } theBlurBgUploadPage`
                  : "mt-[250px] theBlurBgWithoutUpload"
              }  rounded-t-[24px] px-[20px] text-white pb-[20px]`}
            >
              <div className=" ">
                {contestDetails?.contestType == "SP" && (
                  <div className=" flex flex-col items-center justify-center ">
                    <img
                      src={participateSample}
                      className="h-auto w-[50%] mb-[10px] mt-[-300px] z-1 relative"
                    />
                  </div>
                )}
                {contestDetails?.contestType == "WP" && (
                  <div className=" flex flex-col items-center justify-center ">
                    <img
                      src={participateSampleWp}
                      className="h-auto w-[50%] mb-[10px] mt-[-300px] z-1 relative"
                    />
                  </div>
                )}
              </div>

              {_.isEmpty(source) ? (
                <div className="w-[100%] text-center relative z-1 pt-[24px]">
                  <p className="text-regular mb-[10px]">
                    {contestDetails?.contestType == "PHOTO_BOOTH"
                      ? "Take "
                      : "Upload "}
                    {contestDetails?.contestType.startsWith("QUIZ") &&
                      "Participant "}
                    {contestDetails?.contestType.startsWith("REVIEW") &&
                      "Reviewer "}
                    {contestDetails?.fileType?.startsWith("video") && "Video"}
                    {contestDetails?.fileType?.startsWith("image") && "Photo"}
                    {contestDetails?.fileType?.startsWith("audio") && "Audio"}
                  </p>
                  <p className="text-small mb-[24px] text-[#606060]">
                    {contestDetails?.uploadDescription || (
                      <>
                        {contestDetails?.contestType.startsWith("QUIZ") ||
                        contestDetails?.contestType.startsWith("REVIEW")
                          ? "We're capturing your photo to showcase your entry. To ensure smooth submission  process please carefully fill out the questions after uploading."
                          : "We're excited to see your creative entry. To ensure a smooth submission process, please carefully fill out the questions after uploading."}
                      </>
                    )}
                  </p>
                  {eventCondition()}
                </div>
              ) : (
                <div className="w-[100%] text-center relative z-1 pt-[24px]">
                  <p className="text-regular mb-[10px]">
                    Fill the form below to continue
                  </p>
                  <p className="text-small mb-[24px] text-[#606060]">
                    We're excited to see your creative entry. To ensure a smooth
                    submission process, please carefully fill out the questions.
                  </p>
                </div>
              )}
              {contestDetails &&
                contestDetails.fileType?.startsWith("image") && (
                  <div className="z-1 relative">
                    {_.isEmpty(source) && (
                      <div className="flex flex-col  items-center justify-center h-[90%] w-[100%]">
                        <input
                          type="file"
                          multiple={contestDetails?.multipleUpload}
                          onChange={handleFileChange}
                          ref={inputRef}
                          className="hidden"
                          accept="image/*"
                          id={`UB_${contestDetails?.contestId}`}
                        />
                        {/* <button type="submit" onClick={uploadGoviralMedias}>
                        Next
                      </button>
                      <progress max="100" value={progress} />
                      {progress} */}

                        <div className="flex flex-col items-center justify-center">
                          {contestDetails?.contestType !== "PHOTO_BOOTH" && (
                            <button
                              onClick={handleChoose}
                              className="flex items-center justify-center"
                            >
                              {/* <p className="upload-text">Select from gallery</p> */}
                              <div
                                // className="donlode_app "
                                className="commonButton"
                                style={{
                                  backgroundColor: contestDetails?.buttonColor,
                                }}
                              >
                                Upload
                              </div>
                            </button>
                          )}
                          {contestDetails?.contestType == "PHOTO_BOOTH" && (
                            <button
                              onClick={handleChoosePhotoBooth}
                              className="flex items-center justify-center"
                            >
                              {/* <p className="upload-text">Select from gallery</p> */}
                              <div
                                // className="donlode_app "
                                className="commonButton"
                                style={{
                                  backgroundColor: contestDetails?.buttonColor,
                                }}
                              >
                                Continue
                              </div>
                            </button>
                          )}
                        </div>
                      </div>
                    )}

                    {!_.isEmpty(source) && (
                      <>
                        {source.length == 1 ? (
                          <div className=" w-[100%]">
                            <div className="h-[320px] h-auto w-[100%] overflow-hidden flex items-start justify-center mb-[15px] bg-[#1c1c1c]">
                              <img
                                src={source[0]}
                                className=" outline-none w-auto h-[100%] object-contain"
                              />
                            </div>
                            {isEmpty(generatedPosterUrl) && (
                              <button
                                className="text-small text-[#8B8B8B] bg-[#1c1c1c] rounded-[6px] py-[8px] px-[17px]"
                                onClick={() => handleDelete(source[0])}
                              >
                                Replace Photo
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="grid grid-cols-3 gap-[18px]">
                            {source.map((url) => {
                              return (
                                <div className="pb-[20px] w-[100%] relative h-[120px]">
                                  <div
                                    className="flex items-center justify-center absolute right-[-10px] top-[-10px] h-[20px] w-[20px] rounded-full bg-[#363636] p-[7px] cursor-pointer"
                                    onClick={() => handleDelete(url)}
                                  >
                                    <img src={closebutton} alt="x" />
                                  </div>
                                  <div className="h-[100%] w-[100%] overflow-hidden flex items-start justify-center">
                                    <img
                                      src={url}
                                      className="outline-none w-auto h-[100%] object-cover"
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <UploadFormNew
                          uploadGoviralMedias={uploadGoviralMedias}
                          uploadFlow2={uploadFlow2}
                          contestDetails={contestDetails}
                          formDetails={formDetails}
                          setFormDetails={setFormDetails}
                          setThumbnail={setThumbnail}
                          loading={loading}
                          quizQuestions={quizQuestions}
                          setDefaultThumbnail={setDefaultThumbnail}
                          setOtherMedias={setOtherMedias}
                          youtubeLinks={youtubeLinks}
                          patchDetails={patchDetails}
                          extractedFrameThumbnail={extractedFrameThumbnail}
                        />
                      </>
                    )}
                  </div>
                )}
              {contestDetails &&
                contestDetails.fileType?.startsWith("video") && (
                  <div className="z-1 relative">
                    {_.isEmpty(source) && (
                      <div className="flex  items-center justify-center h-[90%] w-[100%]">
                        <input
                          type="file"
                          multiple={contestDetails?.multipleUpload}
                          onChange={handleFileChange}
                          ref={inputRef}
                          className="hidden"
                          accept="video/*"
                          id={`UB_${contestDetails?.contestId}`}
                        />
                        <div className="flex flex-col gap-[10px] items-center justify-center">
                          <button
                            onClick={handleChoose}
                            className="flex items-center justify-center"
                          >
                            {/* <p className="upload-text">Select from gallery</p> */}
                            <div
                              // className="donlode_app "
                              className="commonButton"
                              style={{
                                backgroundColor: contestDetails?.buttonColor,
                              }}
                            >
                              Upload
                            </div>
                          </button>
                          {contestDetails?.youtubeUpload && (
                            <>
                              <p>OR</p>
                              <button
                                onClick={handleYoutubeUpload}
                                className="flex gap-[5px] items-center justify-center commonButton bg-[#ffa9a9]"
                              >
                                <img
                                  src={youtube}
                                  alt=""
                                  className="h-[24px] w-[24px]"
                                />
                                Provide Youtube Link
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {!_.isEmpty(source) && (
                      <>
                        {source.length == 1 ? (
                          <div className="w-[100%]">
                            <div className="h-[320px] h-auto w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                              <ReactPlayer
                                controls={true}
                                // width="auto"
                                height="100%"
                                url={source[0]}
                                style={{ objectFit: "contain" }}
                              />
                            </div>

                            <button
                              className="text-small text-[#8B8B8B] bg-[#1c1c1c] rounded-[6px] py-[8px] px-[17px]"
                              onClick={() => handleDelete(source[0])}
                            >
                              Replace Video
                            </button>
                          </div>
                        ) : (
                          <div className="grid grid-cols-2 gap-[18px]">
                            {source.map((url) => {
                              return (
                                <div className="pb-[20px] w-[100%] relative h-[120px]">
                                  <div
                                    className="flex items-center justify-center absolute right-[-10px] top-[-10px] h-[20px] w-[20px] rounded-full bg-[#363636] p-[7px] cursor-pointer"
                                    onClick={() => handleDelete(url)}
                                  >
                                    <img src={closebutton} alt="x" />
                                  </div>
                                  <div className="h-[100%] w-[100%] overflow-hidden flex items-start justify-center">
                                    <ReactPlayer
                                      width="auto"
                                      height="100%"
                                      controls={true}
                                      url={url}
                                      muted
                                      style={{ objectFit: "cover" }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <UploadFormNew
                          uploadGoviralMedias={uploadGoviralMedias}
                          uploadFlow2={uploadFlow2}
                          contestDetails={contestDetails}
                          formDetails={formDetails}
                          setFormDetails={setFormDetails}
                          setThumbnail={setThumbnail}
                          loading={loading}
                          quizQuestions={quizQuestions}
                          setDefaultThumbnail={setDefaultThumbnail}
                          setOtherMedias={setOtherMedias}
                          youtubeLinks={youtubeLinks}
                          patchDetails={patchDetails}
                          extractedFrameThumbnail={extractedFrameThumbnail}
                        />
                      </>
                    )}
                  </div>
                )}
              {contestDetails &&
                contestDetails.fileType?.startsWith("audio") && (
                  <div className="z-1 relative">
                    {_.isEmpty(source) && (
                      <div className="flex  items-center justify-center h-[90%] w-[100%]">
                        <input
                          type="file"
                          multiple={contestDetails?.multipleUpload}
                          onChange={handleFileChange}
                          ref={inputRef}
                          className="hidden"
                          accept=".mp3,.WAV,.ogg"
                          id={`UB_${contestDetails?.contestId}`}
                        />
                        <div className="flex flex-col items-center justify-center">
                          <button
                            onClick={handleChoose}
                            className="flex items-center justify-center"
                          >
                            {/* <p className="upload-text">Select from gallery</p> */}
                            <div
                              // className="donlode_app "
                              className="commonButton"
                              style={{
                                backgroundColor: contestDetails?.buttonColor,
                              }}
                            >
                              Upload
                            </div>
                          </button>
                        </div>
                      </div>
                    )}

                    {!_.isEmpty(source) && (
                      <>
                        {source.length == 1 ? (
                          <div className="w-[100%]">
                            <div className=" h-[70px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px]">
                              <AudioPlayerWithoutDownload
                                fileUrl={source[0]}
                                fileName="my voice recording"
                              />
                            </div>

                            <button
                              className="text-small text-[#8B8B8B] bg-[#1c1c1c] rounded-[6px] py-[8px] px-[17px]"
                              onClick={() => handleDelete(source[0])}
                            >
                              Replace Audio
                            </button>
                          </div>
                        ) : (
                          <div className="grid grid-cols-2 gap-[18px]">
                            {source.map((url) => {
                              return (
                                <div className="pb-[20px] w-[100%] relative h-[120px]">
                                  <div
                                    className="flex items-center justify-center absolute right-[-10px] top-[-10px] h-[20px] w-[20px] rounded-full bg-[#363636] p-[7px] cursor-pointer"
                                    onClick={() => handleDelete(url)}
                                  >
                                    <img src={closebutton} alt="x" />
                                  </div>
                                  <div className="h-[100%] w-[100%] overflow-hidden flex items-start justify-center">
                                    <ReactPlayer
                                      width="auto"
                                      height="100%"
                                      controls={true}
                                      url={url}
                                      muted
                                      style={{ objectFit: "cover" }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <UploadFormNew
                          uploadGoviralMedias={uploadGoviralMedias}
                          uploadFlow2={uploadFlow2}
                          contestDetails={contestDetails}
                          formDetails={formDetails}
                          setFormDetails={setFormDetails}
                          setThumbnail={setThumbnail}
                          loading={loading}
                          setDefaultThumbnail={setDefaultThumbnail}
                          setOtherMedias={setOtherMedias}
                          youtubeLinks={youtubeLinks}
                          patchDetails={patchDetails}
                          extractedFrameThumbnail={extractedFrameThumbnail}
                        />
                      </>
                    )}
                  </div>
                )}
            </div>
          </div>
          {/* <ContactUsFooter profileHelpNavigate={profileHelpNavigate} /> */}
        </div>
        {uploadSuccess && (
          <UploadSuccess
            uploadSuccessFile={uploadSuccessFile}
            singleFileDetails={contestDetails && contestDetails[0]}
            setUploadSucccess={setUploadSucccess}
            token={token}
            contestDetails={contestDetails}
            handleBackClick={handleBackClick}
          />
        )}
      </div>
    </>
  );
}

export default UploadHome;
